module.exports = __webpack_public_path__ + "img/scotiabank.e54d96d5.png";